// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"7aa12de6","421":"8f95c6e2","787":"d260f806"}[chunkId] + ".chunk.js";
};